import React, { useState } from "react";
import "./Navbar.css";
import logo from "../../assets/icons/myport.png";
import contactMe from "../../assets/icons/contact.png";
import { Link } from "react-scroll";
import menu from "../../assets/icons/menu.png";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo_area">
        <img className="logo_image" src={logo} alt="" />
        <p className="logo">KMB</p>
      </div>
      <div className="desktopMenu">
        <Link
          activeClass="active"
          to="intro"
          duration={500}
          spy={true}
          smooth={true}
          offset={-100}
          className="desktopMenuListItem"
        >
          Home
        </Link>
        <Link
          activeClass="active"
          to="skills"
          spy={true}
          duration={500}
          offset={-10}
          smooth={true}
          className="desktopMenuListItem"
        >
          Skills
        </Link>
        <Link
          activeClass="active"
          to="works"
          spy={true}
          offset={-100}
          duration={500}
          smooth={true}
          className="desktopMenuListItem"
        >
          Portfolio
        </Link>
      </div>
      <button
        className="desktopMenuBtn"
        onClick={() => {
          document
            .getElementById("contact")
            .scrollIntoView({ behavior: "smooth" });
        }}
      >
        <img src={contactMe} alt="" className="desktopMenuImg" />
        Contact Me
      </button>

      {/*  */}

      <img
        src={menu}
        alt="menu"
        className="mobMenu"
        onClick={() => setShowMenu(!showMenu)}
      />

      <div className="navMenu" style={{ display: showMenu ? "flex" : "none" }}>
        <Link
          activeClass="active"
          to="intro"
          duration={500}
          spy={true}
          smooth={true}
          offset={-100}
          className="listItem"
          onClick={() => {
            setShowMenu(false);
          }}
        >
          Home
        </Link>
        <Link
          activeClass="active"
          to="skills"
          spy={true}
          duration={500}
          offset={-10}
          smooth={true}
          className="listItem"
          onClick={() => {
            setShowMenu(false);
          }}
        >
          Skills
        </Link>
        <Link
          activeClass="active"
          to="works"
          spy={true}
          offset={-100}
          duration={500}
          smooth={true}
          className="listItem"
          onClick={() => {
            setShowMenu(false);
          }}
        >
          Portfolio
        </Link>
        <Link
          activeClass="active"
          to="contact"
          spy={true}
          offset={-100}
          duration={500}
          smooth={true}
          className="listItem"
          onClick={() => {
            setShowMenu(false);
          }}
        >
          Contact
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
